import requestFormSicknessPanelComponent from './requestFormSicknessPanel.component';

let requestFormSicknessPanelModule = angular.module('vacations-absences.requestFormSicknessPanel', [])

.component('requestFormSicknessPanel', requestFormSicknessPanelComponent)

.name;

export default requestFormSicknessPanelModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRequest/requestForm/requestFormSicknessPanel/requestFormSicknessPanel.js